module.exports = __webpack_public_path__ + "static/media/esp2.fccd4628.jpg";